// UserContext.js
import React, { createContext, useState } from "react";

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const getUserDetail = async (token) => {
    try {
      const response = await fetch("http://localhost:5000/userProfile", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setUserDetails(data);
      } else {
        console.log("Failed to fetch user details");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false); // Ensure loading is set to false after the fetch completes
    }
  };

  return (
    <UserContext.Provider
      value={{ userDetails, loading, getUserDetail, setUserDetails }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserProvider, UserContext };
